import type { Order } from '@shared/types';

interface Props {
  orders: Order[];
}

export default function FailureBreakdown({ orders }: Props) {
  const failedOrders = orders.filter((o) => o.status === 'failed');
  if (failedOrders.length === 0) return null;

  const reasons: Record<string, number> = {};
  for (const o of failedOrders) {
    const events = o.timeline || [];
    const lastEvent = events.length > 0 ? events[events.length - 1] : null;
    const reason = lastEvent?.event || 'Unknown';
    reasons[reason] = (reasons[reason] || 0) + 1;
  }

  const sorted = Object.entries(reasons).sort(([, a], [, b]) => b - a);

  return (
    <div
      className="rounded p-5"
      style={{
        border: '1px solid var(--dash-border)',
        background: 'var(--dash-card)',
      }}
    >
      <div
        className="font-mono text-[10px] uppercase tracking-widest mb-3"
        style={{ color: 'var(--dash-text-dim)' }}
      >
        Failure Breakdown
      </div>
      <div className="space-y-2">
        {sorted.map(([reason, count]) => (
          <div key={reason} className="flex items-center justify-between">
            <span
              className="font-sans text-xs truncate mr-3"
              style={{ color: 'var(--dash-text-muted)' }}
            >
              {reason}
            </span>
            <span className="font-mono text-xs text-red-400 shrink-0">{count}</span>
          </div>
        ))}
      </div>
      <div
        className="mt-3 pt-3 flex items-center justify-between"
        style={{ borderTop: '1px solid var(--dash-border-light)' }}
      >
        <span
          className="font-sans text-xs"
          style={{ color: 'var(--dash-text-dim)' }}
        >
          Total failed
        </span>
        <span
          className="font-mono text-xs"
          style={{ color: 'var(--dash-text-tertiary)' }}
        >
          {failedOrders.length}
        </span>
      </div>
    </div>
  );
}
